<template>
  <el-card :body-style="{ padding: '0px' }">
      <div slot="header" class="survey header">
            <img :src="require('./image/new-survey-header.png')" class="header-icon" />
            <span class="header-title">
                Surveys
            </span>
            <!-- <el-popover v-if="profileQuestionnaires.length > 0" 
                class="send-link"
                popper-class="popper-send"
                v-model="popoverShow"
                placement="bottom-end">
                <ul class="send-questionnaire-list">
                    <li v-for="(q, index) in profileQuestionnaires" 
                        class="questionnaire-item"
                        :key="index"
                        @click="sendSingleQuestionnaire(q.id)">
                        {{ q.display_name || q.title }}
                    </li>
                </ul>
                <span slot="reference">
                    <template v-if="sendingQuestionnaire">
                        <LoadSpinner class="load-spinner"></LoadSpinner>
                    </template>
                    <template v-else>
                        New Survey
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </template>
                </span>
            </el-popover>
            <el-cascader
                v-if="showMultiProviders"
                class="questionnaire-cascader"
                v-model="selectedProviderQuestionnaire"
                :options="multiProviderQuestionnaireList"
                @change="handleQuestionnaireChange"
                >
            </el-cascader> -->
        </div>
        <QuestionnaireTable :patient="patient" 
            :questionnaire="questionnaire" 
            :most-recent="true" 
            :is-survey="isSurvey"
            :profile-questionnaires-id="profileQuestionnairesId"
            @answer-now="sendSingleQuestionnaire">
        </QuestionnaireTable>
  </el-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OverviewCard from '..'
import FileTable from './FileTable'
import LoadSpinner from '@/module/component/icon/LoadSpinner.vue'
import TickIcon from '@/module/patient/icon/Tick.vue'
import LoadingButton from '@/module/component/LoadingButton.vue'
import FileHeader from './image/file-header.png'
import QuestionnaireTable from '@/module/patient/card/questionnaire/Table.vue'
import SurveyTable from './SurveyTable'


export default {
    name: 'patient-survey-card',
    extends: OverviewCard,

    data() {
        return {
            addNew: false,
            questionnaireUrl: null,
            creatingFile: false,
            hasCreatedFile: false,
            selectedProviderQuestionnaire: [],
            sendingQuestionnaire: false,
            popoverShow: false
        }
    },

    methods: {
        ...mapActions('provider', [
            'sendSurvey',
        ]),
        doUpload(uploadFile) {
            if (this.$refs.attachFile && this.$refs.attachFile.files.length > 0) {
                this.attachStatus = 'ongoing'
                this.attachingFile = this.$refs.attachFile.files[0]
                this.uploadFile({
                    file: this.attachingFile,
                    patientId: this.patient.id
                })
                .then((uploadUrl) => {
                    this.uploadUrl = uploadUrl
                    this.attachStatus = 'complete'
                })
                .catch((error) => {
                    this.attachStatus = 'none'
                })
            }
        },
        addNewFile() {
            const fileObj = {
                name: this.fileName,
                url: this.uploadUrl,
                profile: this.patientProviderProfileList[0].profile,
                category_id: this.fileType,
                comment: ''
            }
            this.creatingFile = true
            this.createFile({ 
                provider: this.patientProviderProfileList[0].provider,
                patient: this.patient.id,
                fileObj 
                })
                .then((response) => {
                    this.hasCreatedFile = true
                    this.creatingFile = false
                    this.addNew = false
                })
        },
        closeNewFile() {
            this.attachStatus = 'none'
            this.attachingFile = null
            this.uploadUrl = null
            this.fileName = ''
            this.fileType = ''
            this.creatingFile = false
            this.hasCreatedFile = false
            this.addNew = false
        },
        sendSingleQuestionnaire(questionnaire) {
            const provider = this.getProvider ? this.getProvider.provider : this.patientProviderProfileList[0].provider
            const profile = this.getProvider ? this.patientProviderProfileList.find(({provider}) => provider === this.getProvider.provider ).profile : this.patientProviderProfileList[0].profile
            this.popoverShow = false
            this.sendQuestionnaire(questionnaire, provider, profile)
        },
        handleQuestionnaireChange(questionnaireValue) {
            if(questionnaireValue && Array.isArray(questionnaireValue) && questionnaireValue.length == 2) {
                const [provider, profile] = questionnaireValue[0].split(':')
                this.sendQuestionnaire(questionnaireValue[1], provider, profile)
            }
        },
        sendQuestionnaire(questionnaire, provider, profile) {
            console.log(questionnaire, provider, profile)
            this.sendingQuestionnaire = true
            this.sendSurvey({
                ref_id: questionnaire,
                ref_type: 'questionnaire',
                requested_by:  this.getUser.id,
                text: 'This is a survey',
                patient: this.patient.id,
                provider,
                profile,
            })
            .then((questionaireUrl) => {
                this.sendingQuestionnaire = false
                const questionUrl = questionaireUrl
                if(questionUrl)
                    window.open(questionUrl, '_blank')
            })
            .catch(() => {
                this.sendingQuestionnaire = false
            })
        }
    },
    computed: {
        ...mapGetters('provider', [
            'getPatientProviderProfileList',
            'getProviderNameById',
            'getPatientSchedule',
            'getPatientMessages',
            'getPatientProvider',
            'getPatientSurveys'
        ]),
        ...mapGetters('content', [
            'getProfileContent',
        ]),
        ...mapGetters('user', [
            'getUser'
        ]),
        patientProviderProfileList() {
            return this.getPatientProviderProfileList(this.patient.id)
        },
        patientFileCategories() {
            if(this.patientProviderProfileList && this.patientProviderProfileList.length == 1)
                return this.getContentKey('profile', this.patientProviderProfileList[0].profile, 'file_categories')
            return []
        },
        profileQuestionnaires() {
            var questionnaires = []
            this.patientProviderProfileList.map(({ profile }) => {
                let p = this.getContent('profile', profile)
                console.log(p)
                if (p && p.survey_questionnaire && this.getContent('questionnaire', p.survey_questionnaire)) {
                    questionnaires.push.apply(questionnaires, this.getContent('questionnaire', p.survey_questionnaire))
                }
            })
            return questionnaires
        },
        profileQuestionnairesId() {
            return [...new Set(this.profileQuestionnaires.map(({id}) => id))]
        },
        multiProviderQuestionnaireList() {
            try {
                return this.patientProviderProfileList
                    .map(({provider, profile}) => {
                        const value = provider + ':' + profile,
                            label = `${this.getProviderNameById(provider)} (${this.getContentKey('profile', profile, 'title')})`
                        const children = this.getProfileContent(profile, 'survey_questionnaire')
                            .map((questionId) => this.getContent('questionnaire', questionId))
                            .map(({ id, title }) => ({ value: id, label: title }))
                        return {
                            value,
                            label,
                            children
                        }
                    })
            } catch (error) {
                console.error('Problem Calculating multiProviderQuestionnaireList ', error)
                return []
            }
        },
        questionnaire() {
            return this.getPatientSurveys(this.patient.id)
        }
    },

    components: {
        QuestionnaireTable,
        LoadSpinner,
        SurveyTable
    }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
.send-questionnaire-list {
    list-style: none;
    margin-block-start: 0;
    padding-inline-start: 0;
    margin-block-end: 0;
    max-height: 400px;
    overflow-y: scroll;
    li {
        cursor: pointer;
        padding: 10px;
    }
    li:hover {
        background-color: #f8f8f8;
    }
}
</style>

<style lang="css" scoped>
.el-card >>> .el-card__header {
    height: 25px;
}

.header-icon {
    height: 39px !important;
    /* margin-top: 0px !important; */
}

.questionnaire-table >>> .questionnaire.analysis {
	background: #EDF8DF;
	padding: 15px 12px;
	border-top: 1px solid #709F34;
}

.questionnaire-table >>> .choice.selected {
	background: #EDF8DF;
	color: #709F34;
	border-color: #709F34;
	font-weight: bold;
}

.questionnaire-table >>> .slider .tick.selected {
    color: #709F34;
    font-weight: 700;
}

.questionnaire-table >>> .slider .tick.selected .tick-int::before {
    border-color: #709F34;
}

.questionnaire-table >>> .image-upload .response-image .image-holder {
    border: 1px solid #709F34;
}

.questionnaire-table >>> .human-map ul.part-list li {
    color: #709F34;
    background: #EDF8DF;
    border: 1px solid #709F34;
}

.questionnaire-table >>> .multi-question-response .answer-holder .answer {
    color: #709F34;
}

.questionnaire-table >>> .stars svg.el-icon-star-off  path{
	stroke: #EEE;
}

.questionnaire-table >>> .stars svg path {
	stroke: #709F34;
}

.questionnaire-table >>> .stars label {
	color: #709F34;
}

.questionnaire-table >>> .sign-and-date {
	color: #709F34;
}

.questionnaire-table >>> .choice.answer {
	color: #709F34;
}
</style>
